import { render, staticRenderFns } from "./AbbreviationsDialog.vue?vue&type=template&id=6eac39f2"
import script from "./AbbreviationsDialog.vue?vue&type=script&lang=js"
export * from "./AbbreviationsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports